import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

// Pages
import HomePage from "@/pages/HomePage";
import MaineCoonPage from "@/pages/MaineCoonPage";
import ElevagePage from "@/pages/ElevagePage";
import LivreDorPage from "@/pages/LivreDorPage";
import ContactPage from "@/pages/ContactPage";
import MentionsLegalesPage from "@/pages/MentionsLegalesPage";
import PolitiqueConfidentialitePage from "@/pages/PolitiqueConfidentialitePage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/maine-coon" element={<MaineCoonPage />} />
          <Route path="/elevage" element={<ElevagePage />} />
          <Route path="/livre-dor" element={<LivreDorPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/mentions-legales" element={<MentionsLegalesPage />} />
          <Route path="/politique-confidentialite" element={<PolitiqueConfidentialitePage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
